import React from "react";

function DataEmpty() {
  return <div className="empty">No Data Available</div>;
}

export default DataEmpty;
